import React, { useState } from "react";

const ReviewSound = ({ soundUrl }) => {
  const [audioErr, setAudioErr] = useState(null);
  const onAudioError = (err) => {
    setAudioErr(
      <span>
        Sorry we are unable to play back this recording. Please connect with our{" "}
        <a target="_blank" href="https://www.knowlarity.com/support.html">
          Support team
        </a>
        .
      </span>
    );
  };

  return (
    <div className="mt-15 review-audio">
      <span className="d-block mb-5">
        <strong>Review Sound</strong>
      </span>
      <audio
        className="controls"
        controlsList="nofullscreen nodownload noremoteplayback noplaybackrate nomuted"
        src={`${soundUrl}`}
        controls
        onError={onAudioError}
      />
    </div>
  );
};

export default ReviewSound;
